// src/components/ContactView.js
import { useState } from "react";
import { contact, donation } from "../data/contact.js";
import QRCode from "../gallery/QRCode.png";

function CopyField({ label, value }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // ignore errors
    }
  };

  return (
    <div
      className="flex items-center justify-between gap-2 rounded-lg border border-[var(--color-mint-200)] bg-white px-1 py-3"
      title={value}   // 👈 shows full text on hover
    >
      <div className="min-w-0">
        <div className="text-xs text-[var(--color-fern-500)]">{label}</div>
        <div className="text-sm font-medium text-[var(--color-ink)] truncate">
          {value}
        </div>
      </div>
      <button
        type="button"
        onClick={copy}
        className="inline-flex items-center justify-center rounded-lg border border-[#4e977f] px-3 py-1.5 text-xs font-semibold text-[#0e1b17] transition whitespace-nowrap"
      >
        {copied ? "Copied" : "Copy"}
      </button>
    </div>
  );
}

export default function Contact() {

  return (
    <section className="container-pad py-6">
      <div className="w-full max-w-[960px] mx-auto">
        {/* Header */}
        <header className="mb-5 text-center">
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-[var(--color-ink)]">
            Donate
          </h1>
          <p className="muted mt-2">
          As a non-profit NGO, we rely heavily on the kindness and support of donors and collaborators all over the world.
          Please consider making a donation to support our efforts!
          </p>
        </header>

        {/* Contact + UPI */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 justify-center items-center">
          {/* Contact */}
          <div className="card p-5 mx-auto">
            <h3 className="heading-2 mb-2">Contact Us</h3>
            <div className="space-y-3">
              <a
                className="flex items-center gap-3 text-sm text-[var(--color-ink)] hover:underline"
                href={`tel:${contact.phone.replace(/\s/g, "")}`}
              >
                📞 <span className="font-medium">{contact.phone}</span>
              </a>
              <a
                className="flex items-center gap-3 text-sm text-[var(--color-ink)] hover:underline"
                href={`https://wa.me/${contact.whatsapp.replace(/\D/g, "")}`}
                target="_blank"
                rel="noreferrer"
              >
                💬 <span className="font-medium">WhatsApp: {contact.whatsapp}</span>
              </a>
              <a
                className="flex items-center gap-3 text-sm text-[var(--color-ink)] hover:underline"
                href={`mailto:${contact.email}`}
              >
                ✉️ <span className="font-medium">{contact.email}</span>
              </a>
              <a
                className="flex items-start gap-3 text-sm text-[var(--color-ink)] hover:underline"
                href={contact.map}
                target="_blank"
                rel="noreferrer"
              >
                📍 <span className="font-medium">{contact.address}</span>
              </a>
            </div>

            {/* quick actions */}
            <div className="mt-4 flex flex-wrap gap-7">
              <a href={`mailto:${contact.email}`} className="btn-primary h-10 px-6">
                Email Us
              </a>
              <a
                href={`https://wa.me/${contact.whatsapp.replace(/\D/g, "")}`}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center h-10 px-5 rounded-xl bg-white border border-[#4e977f] text-sm font-semibold text-[var(--color-ink)]"
              >
                WhatsApp
              </a>
            </div>
          </div>


        </section>

        {/* Donate via Bank */}
        <section className="card p-5">
          <h3 className="heading-2 mb-3">Donate via Bank Transfer</h3>
          <p className="muted mb-3">{donation.note}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <CopyField label="Account Name" value={donation.bank.accountName} />
            <CopyField label="Account Number" value={donation.bank.accountNumber} />
            <CopyField label="IFSC" value={donation.bank.ifsc} />
            <CopyField label="Bank" value={donation.bank.bankName} />
            <CopyField label="Branch" value={donation.bank.branch} />
          </div>

          <div className="mt-4 text-xs text-[var(--color-fern-500)]">
            Please email us the transaction details for an acknowledgment receipt.
          </div>
        </section>
      </div>
    </section>
  );
}
